module.exports = __webpack_public_path__ + "img/tpc-23.844f6c8c.webp";